import enLocale from 'element-ui/lib/locale/lang/en'
export default {
  languages: [{
    text: 'Chinese',
    val: 'zh'
  }, {
    text: 'English',
    val: 'en'
  }],
  international: {
    message: {
      title: 'IWOS Engineering Auxiliary System',
      password: 'password',
      varificationCode: 'code',
      userValidation: 'Please enter the user name!',
      mailValidation: 'Please enter the correct email!',
      passwordValidation: 'Please enter password!',
      codeValidation: 'Verification code error!',
      landing: 'landing',
      add: 'add',
      delete: 'delete',
      deleteSth: "delete{0}",
      authCode: 'Auth code',
      machineCode: 'machine code',
      user: 'user',
      phone: 'Mobile phone',
      authType: 'auth Type',
      status: 'status',
      expires: 'expires',
      createTime: 'Create time',
      updateTime: 'Update time',
      untreated: 'untreated',
      treated: 'treated',
      cancel: 'cancel',
      determine: 'determine',
      phoneApplication: 'Phone application',
      appApplication: 'App application',
      equipmentQuery: 'device query',
      faultManage: 'Fault Manage',
      faultDevice: 'Fault device',
      faultOrder: 'Fault order',
      userManage: 'User manage',
      engineerManage: 'Engineer manage',
      customerManage: 'Uustomer manage',
      authManage: 'Auth manage',
      appAuth: 'App auth',
      magickeyAuth: 'Magickey auth',
      magickey: 'Magickey',
      enterMagickey: 'Please enter the magickey',
      engineeringManage: 'Engineering',
      documentManual: 'Document manual',
      cancellation: 'cancellation',
      exit: 'Determine to exit this account?',
      prompt: 'prompt',
      error: 'User or password error!',
      LoginFailed: 'Login failed, please login again',
      timeRange: 'Selection time range',
      types: 'All types',
      all: 'all',
      enterContent: 'Please enter content',
      type: 'type',
      search: 'search',
      serialNumber: 'serialNumber',
      siteName: 'siteName',
      agent: 'agent',
      owner: 'owner',
      Unassigned: 'Unassigned order',
      processing: 'processing',
      latestWeek: 'Latest week',
      LastMonth: 'Last month',
      LastMonths: 'Last 3 months',
      timeWrong: 'The query time is wrong, please select the correct time.',
      deletePrompt: 'This operation will permanently delete the record. Will it continue?',
      selectUser: 'Select the user to delete',
      enterPhone: 'Please enter the phone number of the authorized person',
      validation: 'validation',
      selectDate: 'Select a date',
      failed: 'Failed',
      success: 'Success',
      enterPhoneNumber: 'Please enter phone number.',
      correctPhoneNumber: 'Please enter the correct phone number.',
      correctMachineCode: 'Please enter the correct machine code',
      enterValidity: 'Please enter validity period',
      pleaseVerify: 'Please verify',
      correctInformation: 'Please enter the correct information.',
      editFailure: 'Edit failure',
      correctEngineer: 'Please enter the correct engineer.',
      AuthSuccessful: 'Authentication is successful',
      newAuth: 'new auth',
      editAuth: 'Edit auth',
      editDevice: 'Edit equipment',
      finalUser: 'finalUser',
      modifyFailure: 'Modify the failure',
      ModifySuccess: 'Modify the success',
      businessStatus: 'Select business status',
      SdeviceType: 'Please select device type!',
      ScreateTime: 'Please Select create time',
      BindEquipment: 'Bind equipment fault',
      DeviceType: 'Device type',
      BusinessState: 'Business state',
      station: 'station',
      line: 'line',
      inventory: 'inventory',
      debugging: 'debugging',
      run: 'run',
      fault: 'fault',
      maintenance: 'maintenance',
      scrap: 'scrap',
      exception: '{0}failure type',
      exceptionBall: '{0}ball failure type',
      Sdevice: 'Please select device',
      SdeviceIWOC: 'Select the device type that is IWOC',
      none: 'none',
      onlyDevice: 'Only one device can be selected',
      DFaultType: 'Please select device fault type',
      siteMissing: 'This site is missing, please go to the cancellation management page for updates',
      FBindDevice: 'Failed to bind the device',
      SBindDevice: 'The binding device failed successfully',
      device: 'one device',
      order: 'one work order',
      leastOne: 'Please select at least {0}',
      repairOrder: 'Add to the repair order',
      bindingOrder: 'The binding work order',
      sbindingOrder: 'Please select the binding worksheet',
      deleteOrder: 'Delete the repair order',
      orderNumber: 'Work order no',
      name: 'name',
      head: 'head',
      Pselect: 'Please select{0}',
      EquipmentList: 'Equipment list',
      detailed: 'detailed',
      noEquipment: 'There is no equipment',
      noAssigned: 'Not assigned',
      orderMessage: 'New construction sheet and add equipment to the work list.',
      newWorkSheet: 'Please enter the name of the new work sheet.',
      addMessage: 'Add device to existing worksheet',
      removeEquipment: 'Remove equipment',
      site: 'site',
      solution: 'The solution',
      time: 'The time',
      phases: '{0}phases',
      devicesCompleted: 'You can only delete devices that have been completed.',
      newOrder: 'New work order failed',
      UnassignedMeg: 'Select {0} device, please',
      UnselectedOrder: 'Unselected work order',
      bindListFailed: 'The binding list failed',
      titleMeg1: 'A list of fault points for this work',
      titleMeg2: 'Remove list of single point of failure',
      ontEmpty: '{0} Do not empty',
      updateOrder: 'Update the work order {0}',
      listError: 'Get the project list error.',
      nameS: 'name',
      email: 'email',
      role: 'role',
      jurisdictions: 'jurisdictions',
      coding: 'coding',
      nameOf: 'name',
      PuserRoles: 'Please select User roles',
      PcustomerType: 'Please select The customer type',
      enterName: 'Please enter name',
      entermailbox: 'Please enter the correct mailbox',
      entercustomer: 'Please enter customer number',
      newUsers: 'New users',
      editCustomer: 'Edit the customer',
      newCustomer: 'New customer',
      userAdded: 'User added success',
      engineer: 'engineer',
      agentAdmin: 'agent administrator',
      serialNumber: 'Serial number',
      DUserSuccess: 'Delete user success',
      DUserFailed: 'Delete user failed',
      editUser: 'Edit the user',
      PSbindAgent: 'Please select a binding agent',
      allAgent: 'All agents',
      BelongAgent: 'agents',
      updateInformation: 'Update project personnel information {0}',
      updateAgent: 'Update the agent manager {0}',
      RAgentFailed: 'The request agent failed. Please try again',
      back: 'back',
      save: 'save',
      document: 'document {0}',
      package: 'Package {0}',
      fault1: 'fault {0}',
      describe: 'describe',
      // docContent: 'document content',
      // schemeDes: 'Scheme described',
      // faultDes: 'Fault description',
      content: 'content',
      pleaseEnter: 'Please enter the {0}',
      update: "update",
      newbuild: 'new',
      // newbuild1: 'new {0}',
      fileFailed: '{0} file failed',
      fileSuccess: '{0} File successfully',
      uploadFile: 'Upload a file',
      newDocument: 'New document',
      bindScheme: 'Binding Scheme',
      newPlan: 'New plan',
      newFault: 'new fault',
      creatDate: 'Creation date',
      operation: 'operation',
      view: 'view',
      edit: 'edit',
      downloadFile: 'download file',
      unreadableFile: 'This file is unreadable file, ok?',
      tagName: 'Tag name',
      tagContains: 'This tag contains the document and can only delete empty tags',
      tagExists: 'The tag already exists',
      tagError: 'Get tag error',
      dragFile: 'Drag the file here, or',
      clickUpload: 'Click on the upload',
      onlyUpload: 'Can only upload {0} file',
      fileUploadf: 'file {} Upload failed',
      fileUploadS: 'file {} Uploaded successfully',
      noStandFile: 'There is no standard file.',
      deviceStatus: 'View device status',
      equipmentState: 'Equipment state',
      networkNumber: 'network number',
      stateName: 'name of the state',
      stateValue: 'status value',
      s_dtutime_81C0: 'DTU time',
      s_module_81BE: 'Module',
      s_sn_81BF: 'Serial Number',
      s_dtu_version_81C1: 'DTU Version',
      s_imei: 'IMEI',
      s_imsi: 'IMSI',
      s_iccid: 'ICCID',
      s_cell_signal: 'Signal',
      s_cell_frequence: 'Frequence',
      s_cell_mnc: 'MNC',
      s_cell_mcc: 'MCC',
      s_cell_lac: 'LAC',
      s_cell_reg_num: 'Registered',
      s_cell_cellid: 'CELL ID',
      s_reboot_code: 'Reboot Style',
      s_ppp_auth_type: 'Auth Type',
      s_ppp_lcp_delay: 'LCP Delay',
      s_ppp_connection: 'PPP Connection',
      s_ppp_lose_rate: 'PPP Lose Rate',
      s_net_ip: 'Net IP',
      s_net_received: 'Net Received',
      s_net_send: 'Net Send',
      s_net_ping_delay: 'Net Ping Delay',
      s_app1_connection: 'App1 Connection',
      s_app2_connection: 'App2 Connection',
      s_gps_lock: 'GPS Lock',
      s_oc_baterry: 'OC Baterry',
      s_oc_power_fetch: 'OC Power Fetch Voltage',
      s_oc_cap_fetch: 'Capacitor Voltage',
      s_gps_geo: 'GPS geo',
      s_om_online_A1: 'A1 Online',
      s_om_online_B1: 'B1 Online',
      s_om_online_C1: 'C1 Online',
      s_om_online_A2: 'A2 Online',
      s_om_online_B2: 'B2 Online',
      s_om_online_C2: 'C2 Online',
      s_om_online_A3: 'A3 Online',
      s_om_online_B3: 'B3 Online',
      s_om_online_C3: 'C3 Online',


      longitude: 'longitude',
      latitude: 'latitude',
      s_om_sn_A1: 'A1 serialNumber',
      s_om_reserve_A1: 'A1 reserve',
      s_om_sversion_A1: 'A1 soft version',
      s_om_hversion_A1: 'A1 hart version',
      s_om_vef_A1: 'A1 Electric Field',
      s_om_current_A1: 'A1 Current',
      s_om_o_temperature_A1: 'A1 temperature',
      s_om_baterry_A1: 'A1 Baterry',
      s_om_power_fetch_A1: 'A1 Power Fetch',
      s_om_condition_A1: 'A1 Condition',
      s_om_rssi_A1: 'A1 RSSI',
      s_om_system_A1: 'A1 System State',
      s_om_sleep_A1: 'A1 Sleep',
      s_om_workmode_A1: 'A1 workmode',
      s_om_fault_stat_A1: 'A1 Fault State',
      s_om_battery_stat_A1: 'A1 Battery State',
      s_om_cap_1_A1: 'A1 First Capacity ',
      s_om_cap_2_A1: 'A1 Seconed Capacity',
      s_om_sn_B1: 'B1 serialNumber',
      s_om_reserve_B1: 'B1 reserve',
      s_om_sversion_B1: 'B1 soft version',
      s_om_hversion_B1: 'B1 hart version',
      s_om_vef_B1: 'B1 Electric Field',
      s_om_current_B1: 'B1 Current',
      s_om_o_temperature_B1: 'B1 temperature',
      s_om_baterry_B1: 'B1 Baterry',
      s_om_power_fetch_B1: 'B1 Power Fetch',
      s_om_condition_B1: 'B1 Condition',
      s_om_rssi_B1: 'B1 RSSI',
      s_om_system_B1: 'B1 System State',
      s_om_sleep_B1: 'B1 Sleep',
      s_om_workmode_B1: 'B1 workmode',
      s_om_fault_stat_B1: 'B1 Fault State',
      s_om_battery_stat_B1: 'B1 Battery State',
      s_om_cap_1_B1: 'B1 First Capacity ',
      s_om_cap_2_B1: 'B1 Seconed Capacity',
      s_om_sn_C1: 'C1 serialNumber',
      s_om_reserve_C1: 'C1 reserve',
      s_om_sversion_C1: 'C1 soft version',
      s_om_hversion_C1: 'C1 hart version',
      s_om_vef_B1: 'C1 Electric Field',
      s_om_current_C1: 'C1 Current',
      s_om_o_temperature_C1: 'C1 temperature',
      s_om_baterry_C1: 'C1 Baterry',
      s_om_power_fetch_C1: 'C1 Power Fetch',
      s_om_condition_C1: 'C1 Condition',
      s_om_rssi_C1: 'C1 RSSI',
      s_om_system_C1: 'C1 System State',
      s_om_sleep_C1: 'C1 Sleep',
      s_om_workmode_C1: 'C1 workmode',
      s_om_fault_stat_C1: 'C1 Fault State',
      s_om_battery_stat_C1: 'C1 Battery State',
      s_om_cap_1_C1: 'C1 First Capacity ',
      s_om_cap_2_C1: 'C1 Seconed Capacity',
      suffix: 'unit',

      'conn_ok': 'Connected',
      'conn_no': 'Disconnect',
      'locked': 'Locked',
      'no_locked': 'Unlocked',
      "V": 'V',
      "A": 'A',
      'off_line': 'Offline',
      'online': 'Online',
      'run_state': 'Running',
      'sleep_state': 'Sleep',
      'unregistered': 'Unregistered',
      'registered_native': 'Registered(native)',
      'registered': 'Registered(roaming)',
      "hard_reboot": "Hart reboot",
      "soft_reboot": 'Soft reboot',
      "unable_analyze_device_state": "Can't resolve this device state",
      "have_no_state": "This device has no state",

    },
  },
  ...enLocale
}



// WEBPACK FOOTER //
// ./src/international/en.js